import {actionMap} from '../reducers/index'
import * as types from './types'
import resetError from "../../../../shared/errorHandler/actions/resetError"

export default (params) => dispatch => {
    dispatch(resetError())
    dispatch({
        type: types.SELECT_ALL_DOCUMENTS,
        params: params
    })
}

export const handler_SELECT_ALL_DOCUMENTS = (reduxState, action) => {
    return ({
        ...reduxState,
        selectedIds: action.params.checked ? action.params.ids : []
    })
}

actionMap[types.SELECT_ALL_DOCUMENTS] = handler_SELECT_ALL_DOCUMENTS


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/selectAllDocuments.js